import FormTextInput from "./FormTextInput";

export type { FormTextInputProps } from "./FormTextInput";

export default FormTextInput;
